
import { get, post } from '../../services/api';

export const fetchVendeursEnAttente = async () => {
  const res = await get('/vendeurs/en-attente');
  return res.data;
};

export const validerVendeurById = async (id) => {
  await post(`/vendeurs/${id}/valider`);
};

export const rejeterVendeurById = async (id, remarque) => {
  await post(`/vendeurs/${id}/rejeter`, { remarque });
};
